module.exports = __webpack_public_path__ + "img/6.8580f2f5.jpg";